/*
 * @Author: duyaoyao
 * @Date: 2021-02-02 09:31:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-12 23:20:20
 */
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Vant from 'vant';
import 'vant/lib/index.css';
import services from './util/services';
import 'vue2-toast/lib/toast.css';
import { finalConfig } from './util/config';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 路由守卫修改title
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
Vue.prototype.$api = services;
Vue.prototype.$finalConfig = finalConfig;

Vue.use(Vant);
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
